import * as React from 'react';
import classnames from 'classnames';

import InputCheckbox from 'components/inputs/input-checkbox/InputCheckbox';

import './influencer-modal-actions-menu-item.scss';

import type { CheckboxesListItem, DataStructureComponent } from 'types';

import type { SyntheticEvent } from 'react';

type Props = {
  item: DataStructureComponent,
  isActive?: boolean,
  onItemClick: (a: CheckboxesListItem) => void
};

// reason for using `onMouseDown` instead of `onClick`
// https://stackoverflow.com/a/28963938
const InfluencerModalActionsMenuItem = (
  {
    item,
    isActive,
    onItemClick
  }: Props
): JSX.Element => {
  const handleItemClick = (event: SyntheticEvent<HTMLElement>): void => {
    // handle the result of `onMouseDown` being used instead of `onClick`
    event.preventDefault();

    // @ts-ignore
    onItemClick(item);
  };

  const itemClassName = classnames('influencer-modal-actions-menu-item', {
    'influencer-modal-actions-menu-item--active': isActive
  });

  return (
    <div
      className={itemClassName}
      data-is-checked={item.isSelected}
      onMouseDown={handleItemClick}
    >
      <div className="influencer-modal-actions-menu-item__checkbox">
        <InputCheckbox
          key={`influencer-modal-actions-menu-item__checkbox-${item.identifier}-${item.label}`}
          id={`influencer-modal-actions-menu-item__checkbox-${item.identifier}-${item.label}`}
          name="enabled"
          value={String(item.isSelected)}
          checked={item.isSelected}
        />
      </div>
      <div className="influencer-modal-actions-menu-item__label text-overflow-ellipsis">
        {item.label}
      </div>
    </div>
  );
};

export default InfluencerModalActionsMenuItem;
